import { render, staticRenderFns } from "./Subdistrict.vue?vue&type=template&id=2c330b21"
import script from "./Subdistrict.vue?vue&type=script&lang=js"
export * from "./Subdistrict.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports